export const cryptoRecommendations = [
  // Established Projects
  {
    name: 'Polkadot',
    symbol: 'DOT',
    category: 'Established Projects',
    marketCap: 8_500_000_000,
    keyFeatures: [
      'Cross-chain interoperability',
      'Shared security model',
      'Parachain ecosystem',
      'Governance framework'
    ],
    technology: {
      consensus: 'NPoS (Nominated Proof of Stake)',
      tps: '1,000+',
      features: ['Parachains', 'XCMP', 'Substrate', 'WebAssembly']
    },
    team: {
      type: 'Parity Technologies',
      notable: ['Gavin Wood', 'Robert Habermeier']
    },
    partnerships: [
      'Enterprise Solutions',
      'DeFi Protocols',
      'Cross-chain Projects'
    ],
    recentMilestones: [
      'Parachain Auctions',
      'Cross-chain Messaging',
      'Governance Updates',
      'Network Upgrades'
    ],
    riskFactors: [
      'Technical complexity',
      'Parachain competition',
      'Market dynamics',
      'Regulatory environment'
    ],
    priceHistory: {
      allTimeHigh: 49.35,
      allTimeLow: 2.69,
      yearToDateChange: '+25%'
    },
    volume: {
      daily: 200_000_000,
      monthly: 6_000_000_000
    },
    communityMetrics: {
      twitter: 1_500_000,
      discord: 250_000,
      github: {
        contributors: 300,
        stars: 6000
      }
    }
  },
  {
    name: 'Cosmos',
    symbol: 'ATOM',
    category: 'Established Projects',
    marketCap: 3_800_000_000,
    keyFeatures: [
      'Inter-blockchain Communication',
      'Sovereign blockchains',
      'Tendermint consensus',
      'SDK framework'
    ],
    technology: {
      consensus: 'Tendermint BFT',
      tps: '10,000+',
      features: ['IBC Protocol', 'CosmWasm', 'Cosmos SDK', 'Proof of Stake']
    },
    team: {
      type: 'Cosmos Foundation',
      notable: ['Ethan Buchman', 'Jae Kwon']
    },
    partnerships: [
      'Blockchain Networks',
      'DeFi Platforms',
      'Enterprise Solutions'
    ],
    recentMilestones: [
      'IBC Adoption',
      'Ecosystem Growth',
      'Protocol Upgrades',
      'SDK Enhancements'
    ],
    riskFactors: [
      'Chain competition',
      'Protocol complexity',
      'Market volatility',
      'Adoption challenges'
    ],
    priceHistory: {
      allTimeHigh: 44.70,
      allTimeLow: 1.13,
      yearToDateChange: '+35%'
    },
    volume: {
      daily: 150_000_000,
      monthly: 4_500_000_000
    },
    communityMetrics: {
      twitter: 900_000,
      discord: 180_000,
      github: {
        contributors: 250,
        stars: 5500
      }
    }
  },
  {
    name: 'Polygon',
    symbol: 'MATIC',
    category: 'Established Projects',
    marketCap: 7_200_000_000,
    keyFeatures: [
      'Ethereum scaling',
      'Multi-chain architecture',
      'ZK technology',
      'Low transaction fees'
    ],
    technology: {
      consensus: 'Proof of Stake',
      tps: '65,000+',
      features: ['Plasma', 'PoS Chain', 'ZK Rollups', 'Validium']
    },
    team: {
      type: 'Polygon Labs',
      notable: ['Sandeep Nailwal', 'Jaynti Kanani']
    },
    partnerships: [
      'Enterprise Brands',
      'DeFi Projects',
      'NFT Platforms'
    ],
    recentMilestones: [
      'zkEVM Launch',
      'Enterprise Adoption',
      'Network Upgrades',
      'Ecosystem Expansion'
    ],
    riskFactors: [
      'Layer 2 competition',
      'Technical challenges',
      'Market dependency',
      'Scaling trade-offs'
    ],
    priceHistory: {
      allTimeHigh: 2.92,
      allTimeLow: 0.01,
      yearToDateChange: '+55%'
    },
    volume: {
      daily: 250_000_000,
      monthly: 7_500_000_000
    },
    communityMetrics: {
      twitter: 1_800_000,
      discord: 220_000,
      github: {
        contributors: 180,
        stars: 4200
      }
    }
  },

  // Emerging Projects
  {
    name: 'Injective',
    symbol: 'INJ',
    category: 'Emerging Projects',
    marketCap: 1_200_000_000,
    keyFeatures: [
      'Decentralized derivatives',
      'Cross-chain trading',
      'MEV resistance',
      'Fast finality'
    ],
    technology: {
      consensus: 'Tendermint',
      tps: '10,000+',
      features: ['CosmWasm', 'IBC', 'Orderbook', 'Derivatives']
    },
    team: {
      type: 'Injective Labs',
      notable: ['Eric Chen', 'Albert Chon']
    },
    partnerships: [
      'Trading Platforms',
      'DeFi Protocols',
      'Market Makers'
    ],
    recentMilestones: [
      'Mainnet Upgrade',
      'Protocol Growth',
      'Exchange Integration',
      'New Markets'
    ],
    riskFactors: [
      'Market adoption',
      'Protocol complexity',
      'Competition',
      'Regulatory risks'
    ],
    priceHistory: {
      allTimeHigh: 45.20,
      allTimeLow: 0.59,
      yearToDateChange: '+320%'
    },
    volume: {
      daily: 70_000_000,
      monthly: 2_100_000_000
    },
    communityMetrics: {
      twitter: 250_000,
      discord: 120_000,
      github: {
        contributors: 35,
        stars: 900
      }
    }
  },
  {
    name: 'Starknet',
    symbol: 'STRK',
    category: 'Emerging Projects',
    marketCap: 850_000_000,
    keyFeatures: [
      'ZK Rollup',
      'Cairo language',
      'Ethereum scaling',
      'Developer tools'
    ],
    technology: {
      consensus: 'ZK-STARK',
      tps: '20,000+',
      features: ['Cairo VM', 'STARK Proofs', 'Account Abstraction']
    },
    team: {
      type: 'StarkWare',
      notable: ['Uri Kolodny', 'Eli Ben-Sasson']
    },
    partnerships: [
      'DeFi Projects',
      'Gaming Platforms',
      'Infrastructure Providers'
    ],
    recentMilestones: [
      'Token Launch',
      'Ecosystem Growth',
      'Protocol Upgrades',
      'Developer Adoption'
    ],
    riskFactors: [
      'Technical complexity',
      'Early stage',
      'Competition',
      'Adoption curve'
    ],
    priceHistory: {
      allTimeHigh: 4.50,
      allTimeLow: 1.20,
      yearToDateChange: '+150%'
    },
    volume: {
      daily: 40_000_000,
      monthly: 1_200_000_000
    },
    communityMetrics: {
      twitter: 180_000,
      discord: 90_000,
      github: {
        contributors: 45,
        stars: 1200
      }
    }
  },
  {
    name: 'Render',
    symbol: 'RNDR',
    category: 'Emerging Projects',
    marketCap: 1_500_000_000,
    keyFeatures: [
      'Decentralized GPU rendering',
      'AI compute network',
      'Creative tools',
      'Web3 infrastructure'
    ],
    technology: {
      consensus: 'Proof of Render',
      tps: 'Variable',
      features: ['GPU Sharing', 'OctaneRender', 'AI Processing']
    },
    team: {
      type: 'OTOY',
      notable: ['Jules Urbach', 'Core Team']
    },
    partnerships: [
      'Creative Studios',
      'AI Companies',
      'Content Platforms'
    ],
    recentMilestones: [
      'Network Expansion',
      'AI Integration',
      'Protocol Updates',
      'Tool Development'
    ],
    riskFactors: [
      'Network stability',
      'Hardware demands',
      'Market dynamics',
      'Competition'
    ],
    priceHistory: {
      allTimeHigh: 8.78,
      allTimeLow: 0.36,
      yearToDateChange: '+280%'
    },
    volume: {
      daily: 90_000_000,
      monthly: 2_700_000_000
    },
    communityMetrics: {
      twitter: 160_000,
      discord: 70_000,
      github: {
        contributors: 30,
        stars: 800
      }
    }
  },

  // Meme Coins
  {
    name: 'BONK',
    symbol: 'BONK',
    category: 'Meme Coins',
    marketCap: 160_000_000,
    keyFeatures: [
      'Solana meme token',
      'Dog theme',
      'Community driven',
      'DeFi integration'
    ],
    technology: {
      consensus: 'N/A (SPL Token)',
      tps: 'Solana Network',
      features: ['Token Burns', 'Staking', 'Rewards']
    },
    team: {
      type: 'Community',
      notable: ['Anonymous Team']
    },
    partnerships: [
      'Solana Projects',
      'NFT Collections',
      'Gaming Platforms'
    ],
    recentMilestones: [
      'Exchange Listings',
      'DeFi Integration',
      'Community Growth',
      'Token Burns'
    ],
    riskFactors: [
      'High volatility',
      'Meme dependency',
      'Market sentiment',
      'Network risks'
    ],
    priceHistory: {
      allTimeHigh: 0.00000487,
      allTimeLow: 0.000000068,
      yearToDateChange: '+900%'
    },
    volume: {
      daily: 15_000_000,
      monthly: 450_000_000
    },
    communityMetrics: {
      twitter: 250_000,
      telegram: 180_000,
      discord: 120_000
    }
  },
  {
    name: 'PEPE',
    symbol: 'PEPE',
    category: 'Meme Coins',
    marketCap: 140_000_000,
    keyFeatures: [
      'Ethereum meme token',
      'Frog theme',
      'Community focus',
      'Viral potential'
    ],
    technology: {
      consensus: 'N/A (ERC-20)',
      tps: 'Ethereum Network',
      features: ['Meme Economy', 'Social Tokens']
    },
    team: {
      type: 'Anonymous',
      notable: ['Community-Led']
    },
    partnerships: [
      'Meme Communities',
      'Social Media',
      'Content Creators'
    ],
    recentMilestones: [
      'Market Cap Growth',
      'Exchange Listings',
      'Community Events',
      'Social Integration'
    ],
    riskFactors: [
      'Extreme volatility',
      'Meme lifecycle',
      'Market sentiment',
      'Zero utility'
    ],
    priceHistory: {
      allTimeHigh: 0.00000431,
      allTimeLow: 0.000000043,
      yearToDateChange: '+700%'
    },
    volume: {
      daily: 20_000_000,
      monthly: 600_000_000
    },
    communityMetrics: {
      twitter: 300_000,
      telegram: 200_000,
      discord: 150_000
    }
  },
  {
    name: 'FLOKI',
    symbol: 'FLOKI',
    category: 'Meme Coins',
    marketCap: 170_000_000,
    keyFeatures: [
      'Multi-chain token',
      'Viking theme',
      'Community driven',
      'Gaming elements'
    ],
    technology: {
      consensus: 'N/A (Multi-chain)',
      tps: 'Various Networks',
      features: ['Cross-chain', 'Gaming', 'NFTs']
    },
    team: {
      type: 'Semi-Anonymous',
      notable: ['Community Team']
    },
    partnerships: [
      'Gaming Projects',
      'NFT Platforms',
      'Sports Teams'
    ],
    recentMilestones: [
      'Chain Expansion',
      'Game Development',
      'Marketing Campaign',
      'Community Growth'
    ],
    riskFactors: [
      'High volatility',
      'Market sentiment',
      'Competition',
      'Regulatory risks'
    ],
    priceHistory: {
      allTimeHigh: 0.00034,
      allTimeLow: 0.000001,
      yearToDateChange: '+600%'
    },
    volume: {
      daily: 25_000_000,
      monthly: 750_000_000
    },
    communityMetrics: {
      twitter: 350_000,
      telegram: 250_000,
      discord: 180_000
    }
  }
];